<template>
  <div
    class="flex flex-wrap align-center"
    data-qa="offers-group-actions-snackbar">
    <ChooseWinnerBtn
      v-if="showActions.chooseWinner"
      :mode="options.elements[0].selectedBid ? 'remove' : 'select'"
      :options="positionsOptions"/>
    <AskQuestion
      v-if="showActions.askQuestion"
      :bids="positionsElements"
      :tender="options.tender"
      @hideActions="options.callback"/>
    <CompareTableBtn
      v-if="showActions.compareTable"
      :elements="elements"
      :route="compareRoute"
      :tender-id="options.tender.tenderId"/>
    <AnnulBidDialog
      v-if="showActions.annulBid"
      :bids="positionsElements"
      :external="showActions.external"
      :tender="options.tender"
      @callback="options.callback"/>
    <template v-if="showActions.bigMode">
      <sButton
        v-for="item in visibleMenuItems"
        :key="item.key"
        color="var(--white-color)"
        :data-qa="item.dataQa"
        :disabled="item.disabled"
        :icon="item.icon"
        :to="item.to"
        type="text"
        @click="item.click && item.click()">
        {{ item.label }}
      </sButton>
    </template>
    <sPopover
      v-else
      ref="subMenuPopover"
      v-model="visibleSubMenu"
      :open-delay="300"
      placement="bottom-end"
      trigger="click">
      <template #reference="{show}">
        <sButton
          v-show="showActions.menu"
          slot="reference"
          color="var(--white-color)"
          :data-qa="`btn-menu-${show ? 'active' : ''}`"
          icon="menu"
          icon-size="20px"
          small
          type="text"/>
      </template>
      <div>
        <MenuItem
          v-for="item in visibleMenuItems"
          :key="item.key"
          :data-qa="item.dataQa"
          :disabled="item.disabled"
          :icon="item.icon"
          :label="item.label"
          :to="item.to"
          @click="item.click && item.click()"/>
      </div>
    </sPopover>
    <SupplierInspectionDecisionModal
      v-if="showMenuSupplierInspectionDecision"
      :show.sync="showDecisionForm"
      :supplier="positionsElements[0]"
      :tender-id="options.tender.tenderId"
      :use-data="false"/>
    <GroupOfferDifferentPrice
      v-if="showMenuItemOfferPrice"
      ref="offerDifferentPrice"
      :dialog.sync="offerDifferentPriceDialog"
      :elements="positionsElements"
      :get-new-price="getNewPrice"
      :is-sale="isSale"
      :tender="options.tender"
      :validate-input="validateInput"
      @close="closeOfferDifferentPrice"/>
  </div>
</template>
<script>
import { tenderMixin, offerDifferentPriceMixin } from 'mixins'
import godModeMixin from 'mixins/godModeMixin'
import { COMPARE_VIEW_LOT_GROUPS, flattenLotGroupPositions } from 'helpers/lotGroupPositions'

import MenuItem from 'components/common/MenuItem.vue'
import AskQuestion from 'components/tenders/dialogs/AskQuestion.vue'
import AnnulBidDialog from 'components/tenders/dialogs/AnnulBidDialog.vue'
import ChooseWinnerBtn from 'components/tenders/tender page/ChooseWinnerBtn.vue'
import CompareTableBtn from 'components/tenders/actions toolbar/CompareTableBtn.vue'
import SupplierInspectionDecisionModal from 'components/supplies/SupplierInspectionDecisionModal.vue'
import GroupOfferDifferentPrice from 'components/tenders/tender page/offer different price/GroupOfferDifferentPrice.vue'

export default {
  name: 'offersGroupActionsToolbar',
  mixins: [tenderMixin, godModeMixin, offerDifferentPriceMixin],
  data() {
    return {
      loading: false,
      showDecisionForm: false,
      visibleSubMenu: false,
      offerDifferentPriceDialog: false
    }
  },
  computed: {
    showMenuAddToStopList() {
      if (this.elements?.length !== 1) {
        return false
      }
      return true
    },
    showMenuSupplierInspectionDecision() {
      if (!this.positionsElements?.length || this.$acl.get.includes('tenders_view')) {
        return false
      }
      const orgIds = new Set(this.positionsElements.map(element => element.bidderInfo.organizationId))
      return orgIds.size === 1 // Ключ организации участника должен быть уникальным
    },
    can_edit() {
      return this.$_checkCanEdit(this.options.tender, this.$_agreements)
    },
    tender() {
      return this.options.tender
    },
    isSale() {
      return this.tender?.biddingType?.isSale
    },
    showMenuItemOfferPrice() {
      if (!this.positionsElements?.length) {
        return false
      }

      if (this.options?.criteryCard?.criterias?.some(c => c.criterionKind === 'VARIANT')) {
        return false
      }

      const status = this.options.tender?.tenderStatus?.id
      const hasDraft = this.positionsElements.some(el => el.foreignBidderBid || el.bidStatus === 'DRAFT')
      return !hasDraft &&
        (
          (status === this.statuseKeys.BID_ANALYSIS && this.$can('send', 'priceConfirmation') && this.options.tender.biddingType.allowPriceRequest) ||
          (status === this.statuseKeys.SUBMISSION && this.$can('counteroffer', 'OnTendering') && this.options.tender.biddingType.allowCounterOffer) ||
          this.options.tender?.tenderAccess?.includes('ALLOW_SEND_PRICE_REQUEST')
        )
    },
    menuItems() {
      return [
        {
          key: 'supplierInspectionDecision',
          show: this.showMenuSupplierInspectionDecision,
          dataQa: 'add-chec-bidder',
          icon: 'plus-circle',
          label: this.$t('Tenders.addVerificationInformation'),
          click: () => { this.showDecisionForm = true; this.visibleSubMenu = false },
        },
        {
          key: 'addToStopList',
          show: this.showMenuAddToStopList,
          dataQa: 'menu-item-add-to-stop-list',
          icon: 'stopped-person',
          label: this.$t('StopLists.AddToStopList'),
          disabled: this.$acl.get.includes('tenders_view'),
          to: {
            name: 'addToStopList',
            params: { org: this.$route.params.org },
            query: {
              usreou: this.positionsElements[0]?.usreou || this.positionsElements[0]?.organizationUsreou || this.positionsElements[0]?.bidderInfo?.usreou,
              id: this.positionsElements[0]?.organizationId || this.positionsElements[0]?.bidderInfo?.organizationId,
              from: this.options.tender.tenderId
            }
          },
        },
        {
          key: 'offerDifferentPrice',
          show: this.showMenuItemOfferPrice,
          dataQa: 'menu-item-offer-different-price',
          icon: 'price-comment',
          label: this.$t('Tenders.OfferDifferentPrice'),
          click: this.openOfferDifferentPrice,
        },
      ]
    },
    visibleMenuItems() {
      return this.menuItems.filter(item => item.show)
    },
    /**
     * Строчні кнопки (askQuestion, chooseWinner, annulBid) рендеряться підряд.
     * Якщо є хоч одна кнопка вкладеного меню — існує меню (гамбургер).
     * Якщо строчних кнопок немає зовсім, а меню є — меню розгортається у строчний вигляд (bigMode).
     */
    showActions() {
      const external = this.hasPositionsElements && this.options.tender.tenderStatus?.id === this.statuseKeys.BID_ANALYSIS && this.$can('have', 'ForeignSupplierBid') && this.positionsElements?.every(bid => bid?.foreignBidderBid && bid.bidderInfo.email === this.first.bidderInfo.email)

      const isNotLotsHistory = this.options.name !== 'lot-offers-history'

      const result = {
        askQuestion: this.showAskQuestion,
        chooseWinner: this.hasPositionsElements && isNotLotsHistory && this.options.name !== 'members' && this.can_edit,
        compareTable: this.hasPositionsElements && !!this.elements.length && this.options.name !== 'members',
        annulBid: external
        || (
          this.hasPositionsElements
          && this.options.name !== 'members' && isNotLotsHistory && this.$can('delete', 'Bid')
          && (this.options.tender.tenderStatus.id === this.statuseKeys.SUBMISSION || this.options.tender.tenderStatus.id === this.statuseKeys.AUCTION)
        ),
        menu: this.showMenuAddToStopList || this.showMenuSupplierInspectionDecision || this.showMenuItemOfferPrice,
      }

      const hasInline = Object.entries(result).some(([key, value]) => key !== 'menu' && value)

      result.toolbar = hasInline || result.menu
      result.bigMode = !hasInline && result.menu

      this.$emit('showActions', result)
      return result
    },
    showAskQuestion() {
      return (this.can_edit || this.options.tender?.tenderAccess?.includes('ALLOW_SEND_SUPPLIER_QUESTION') || this.mixin_isGodMode)
          && this.positionsElements?.length && this.$can('set', 'privateMessageToBidder')
          && !this.options.tender.hasRoute
          && !this.positionsElements.some(bid => bid.foreignBidderBid)
    },
    elements() {
      const result = this.options.elements
        .filter(i => i.bidderInfo?.contactId)
        || []
      return result
    },
    first() {
      return this.positionsElements[0] || {}
    },
    hasPositionsElements() {
      return !!this.positionsElements?.length
    },
    positionsElements() {
      return flattenLotGroupPositions(this.options.elements)
    },
    compareRoute() {
      return {
        name: 'comparativeTable',
        params: { tenderId: this.options.tender?.tenderId, org: this.$route.params.org },
        query: { view: COMPARE_VIEW_LOT_GROUPS },
      }
    },
    positionsOptions() {
      return {
        ...this.options,
        elements: this.positionsElements
      }
    }
  },
  methods: {
    openOfferDifferentPrice() {
      this.visibleSubMenu = false
      setTimeout(() => {
        this.offerDifferentPriceDialog = true
        this.$refs.offerDifferentPrice.setItems()
      }, 100)
    },
    closeOfferDifferentPrice() {
      this.options.callback()
      this.offerDifferentPriceDialog = false
      this.$notice.closeAll()
    },
  },
  watch: {
    showActions() {
      if (this.visibleSubMenu && this.$refs.subMenuPopover) { // Дергаем сабменю, для пересчета позиций
        this.$refs.subMenuPopover.showPopper = !this.$refs.subMenuPopover.showPopper
        this.$nextTick(() => {
          this.$refs.subMenuPopover.showPopper = !this.$refs.subMenuPopover.showPopper
        })
      }
    }
  },
  components: {
    MenuItem,
    AskQuestion,
    AnnulBidDialog,
    ChooseWinnerBtn,
    CompareTableBtn,
    SupplierInspectionDecisionModal,
    GroupOfferDifferentPrice
  },
  props: {
    options: Object,
    reject_condition: Boolean
  },
}
</script>
<style scoped lang="scss">
</style>
